var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:[`spinner-${_vm.type}`]},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }